import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-passengers',
  templateUrl: './passengers.component.html',
  styleUrls: ['./passengers.component.scss']
})
export class PassengersComponent implements OnInit {
  @Input() mobileMode: any = false;
  @Input() airLines: any = false;
  @Input() submit: boolean;
  @Output() formUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() formUpdateAll: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('menuModal') menuModal: MenuComponent;
  public passengers: any = 0;
  public form: FormGroup;
  public showHidden: any = null;
  public totalPasajeros: any = 0;
  public clase: any = 'económica';

  constructor(private fb: FormBuilder) {
    this.passengers = {
      adult: 0,
      child: 0,
      infant: 0,
      baby: 0
    };

    this.form = this.fb.group({
      passengers: this.fb.group({
        adult: ['', []],
        child: ['', []],
        infant: ['', []],
        baby: ['', []]
      }),
      airline: ['', []],
      stops: ['', []],
      cabin: ['Y', []]
    });

    this.form.valueChanges.subscribe((data: any) => {
        this.clase = data.cabin=='Y'? 'económica' : data.cabin=='F'? 'primera clase' : 'ejecutiva';
        this.updateFlights();
      }, (err) => {
        console.error('Error :', err);
      });
  }

  ngOnInit() {
    this.add('adult');
  }

  /**
   * @description Añadir pasajero
   * @param pasajero Pasajero a incrementar
   */
  add(pasajero) {
    this.totalPasajeros = Object.values(this.passengers).reduce((a,b) => (a as any) + b, 0);
    if( this.totalPasajeros  < 9 ){
      this.passengers[pasajero]++;
      let p = this.form.get('passengers') as FormGroup;
      p.controls[pasajero].setValue(this.passengers[pasajero]);
    }
    this.totalPasajeros = Object.values(this.passengers).reduce((a,b) => (a as any) + b, 0);
  }

  /**
   * @description Remover pasajero
   * @param pasajero Pasajero a reducir
   */
  sub(pasajero) {
    this.totalPasajeros = Object.values(this.passengers).reduce((a,b) => (a as any) + b, 0);
    if( this.totalPasajeros  > 0){
      if(this.passengers[pasajero] > 0){
        this.passengers[pasajero]--;
        let p = this.form.get('passengers') as FormGroup;
        p.controls[pasajero].setValue(this.passengers[pasajero]);
      }
    }
    this.totalPasajeros = Object.values(this.passengers).reduce((a,b) => (a as any) + b, 0);
  }

  updatePassengers() {
    //Actualizar formulario
  }

  updateFlights() {
    //Actualiza Output
    this.formUpdate.emit(this.passengers);
    this.formUpdateAll.emit(this.form.value);
  }

  closeModal() {
    this.menuModal.closeMenu();
  }
}
